import { render } from "./Footer1.vue?vue&type=template&id=4564933b&scoped=true"
import script from "./Footer1.vue?vue&type=script&lang=js"
export * from "./Footer1.vue?vue&type=script&lang=js"

import "./Footer1.vue?vue&type=style&index=0&id=4564933b&scoped=true&lang=css"
import "./Footer1.vue?vue&type=style&index=1&id=4564933b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4564933b"]])

export default __exports__